import './lavecchia/style';
import FormStructure from './lavecchia/form_structure';

export default FormStructure;